<h3 class="m-0">{{'modules.valet.valet_invoices.title' | translate}}</h3>
<pv-custom-list-layout
  [hideTitle]="true"
  [storageKey]="'AdminValetAnomalyGrid'"
  [showColumnSettings]="showColumnSettings"
  [columnSettings]="columnSettings"
  [buttonsConfig]="buttonsConfig"
  (columnVisibilityChanged)="onColumnVisibilityChanged($event)"
  (refreshClicked)="onRefresh()"
  (exportClicked)="onExportPageData()">

  <!-- Table Content -->
  <div content>
    <pv-custom-list
      [columns]="columns"
      [dataSource]="this"
      [isLoading]="isLoading">
    </pv-custom-list>
  </div>
</pv-custom-list-layout>


<ng-template #dateTemplate let-row>
    {{ row.date | date:'dd/MM/yyyy' }}
</ng-template>

<ng-template #amountTemplate let-row>
  {{ row.amount ? (row.amount | currency:'EUR':'symbol':'1.2-2':'fr-FR') : '' }}
</ng-template>

<ng-template #fileTemplate let-row>
  <pv-link-display-column
    style="margin-right: 1rem;"
    [routerText]="pdfBtnText"
    [customAction]="redirectToPdf"
    [rowData]="row"
    [status]="'info'">
  </pv-link-display-column>
</ng-template>
